import { useEffect } from "react";
import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../../store/slices/UI";
import TextField from "../../../../../UI/GeneralPurpose/SimpleTextField";

const UIText = {
  "es-CL": { label: "Asunto", placeholder: "asunto del correo" },
  "en-US": { label: "Subject", placeholder: "mail subject" },
};

export const SubjectId = "mail-subject";
const id = SubjectId;

const Subject = () => {
  const { dispatch, UI } = useUIBp();
  const filter = UI.filter ?? "";

  useEffect(() => {
    const subjectMatch = filter.match(/subject:\(([^)]+)\)/);
    const subjectValue = subjectMatch ? subjectMatch[1] : "";

    if (subjectValue) {
      dispatch(UIactions.setField({ id, value: subjectValue }));
    }
  }, [dispatch, filter]);

  return <TextField clearOnUnmount {...{ id: "mail-subject", UIText, size: 12 }} />;
};

export default Subject;
